import api from './index';

interface ReferralAgreementArgs {
  over_18years_agreement: boolean;
}

export const postReferralAgreement = (args: ReferralAgreementArgs) => {
  return api.post(`/v4/agreement`, args);
};
